module.exports = __webpack_public_path__ + "media/images/arrows/down-short-f8af218bbcd9a436440e29d67b061a96.svg";